import { render } from "./SupervisionTable.vue?vue&type=template&id=4568385a"
import script from "./SupervisionTable.vue?vue&type=script&lang=js"
export * from "./SupervisionTable.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SupervisionTable.vue?vue&type=style&index=0&id=4568385a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__